import { render, staticRenderFns } from "./goodsModule.vue?vue&type=template&id=1fa18a02&scoped=true&"
import script from "./goodsModule.vue?vue&type=script&lang=js&"
export * from "./goodsModule.vue?vue&type=script&lang=js&"
import style0 from "./goodsModule.vue?vue&type=style&index=0&id=1fa18a02&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa18a02",
  null
  
)

export default component.exports